var isAtLeastTablet = function () {
        return window.innerWidth >= ICF.Variables.Breakpoints.Tablet;
};

module.exports = isAtLeastTablet;